import { useContext } from 'react';

import { SankeyLayoutContext } from '../context/SankeyLayout.context.js';
import type { SankeyLayoutModel } from '../types/sankey-internal.js';

export const useSankeyLayout = (): SankeyLayoutModel =>
  useContext(SankeyLayoutContext);
